import { render } from "./UnlockUser.vue?vue&type=template&id=90c46ba0&scoped=true"
import script from "./UnlockUser.vue?vue&type=script&lang=js"
export * from "./UnlockUser.vue?vue&type=script&lang=js"

import "./UnlockUser.vue?vue&type=style&index=0&id=90c46ba0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90c46ba0"]])

export default __exports__